module.exports = __webpack_public_path__ + "img/bzzx.6968d533.png";